export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Diesel mechanics and technicians, maintenance technicians, generator set operators and standby power technicians in mining, oil and gas, hospitals, data centers, telecommunications and marine sites, electricians who work with generator sets, fleet supervisors, people entering the field and technical students.',
  ],
  [
    'Content depth?',
    'From engine fundamentals to fuel and support systems, generator sets, maintenance, diagnostics, safe operation and load testing.',
  ],
  [
    'International?',
    'Yes. Based on internationally used concepts and terminology; always follow local codes, site procedures and manufacturer instructions.',
  ],
  [
    'Format?',
    'Technical reference material in professional PDF files with instant access. It is not diagnostic software, editable templates, manufacturer manuals or a course with a certificate.',
  ],
  [
    'Does it replace manuals or safety procedures?',
    "No. It does not replace the manufacturer's manuals and service data, site procedures, lockout/tagout (LOTO), electrical safety standards, the legal requirements of each country or the judgment of qualified and authorized personnel.",
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
